/* eslint-disable */
export default {
    maintenance_page_title: "Momenteel is de site niet beschikbaar",
    maintenance_title: "Wij voeren op dit moment onderhoudswerkzaamheden uit aan het assessment platform.",
    maintenance_description: "Onze excuses voor het ongemak en dank voor je geduld.\nMocht je vragen hebben, neem dan contact op met de helpdesk van LTP\n\nE-mail: online@ltp.nl\nTelefoon: +31 20 30 50 438\n\nDe helpdesk is bereikbaar op werkdagen van 08.30 tot 17.30 uur.",
    maintenance_notification_bar_text_a: "Op",
    maintenance_notification_bar_text_b: "wordt er onderhoud aan ons platform uitgevoerd en is het niet mogelijk om online assessments te doen. We verzoeken je hier rekening mee te houden in de planning."
};
